import { render, staticRenderFns } from "./OndemandWithRegistration.vue?vue&type=template&id=5efd3107&scoped=true&"
import script from "./OndemandWithRegistration.vue?vue&type=script&lang=js&"
export * from "./OndemandWithRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd3107",
  null
  
)

export default component.exports